import DataMapper from './DataMapper'
import InvestigatorActivity from '../../models/InvestigatorActivity'
import InvestigatorActivityRM from '../responsemodel/InvestigatorActivityRM'

export default class InvestigatorActivityDataMapper extends DataMapper<InvestigatorActivityRM, InvestigatorActivity> {
    map = (rm: InvestigatorActivityRM) => new InvestigatorActivity(rm._id, rm.investigator_name, rm.case_data, rm.distance)
}
